<template>
  <v-card
    v-if="favourites != null && favourites.length > 0"
    flat
    width="100%"
    color="transparent"
  >
    <!-- title -->
    <v-card-title class="px-0 py-2">
      <h2 class="black--text homepageTitle">
        {{ $translate('YOUR_FAVOURITES') }}
        <v-icon class="mb-2" color="red">mdi-heart</v-icon>
      </h2>
    </v-card-title>

    <!-- favourites list -->
    <v-card-text class="px-0">
      <v-row class="ma-0" dense>
        <ItemGroup :items="favourites">
          <template v-slot:item="{ item }">
            <v-hover v-slot="{ hover }">
              <v-card :elevation="hover ? 4 : 1" @click="goTo(item)">
                <!-- Picture -->
                <v-img
                  :src="item.PictureUrl"
                  :aspect-ratio="1.618 / 1"
                  class="d-flex align-end categoryImage"
                />

                <!-- Title -->
                <div
                  id="categoryTitle"
                  class="col-12 blue-grey--text text--darken-4 itemTitleFontSize text-center font-weight-bold"
                >
                  {{ truncateName(item.EventTranslationName || item.Name) }}
                </div>
              </v-card>
            </v-hover>
          </template>
        </ItemGroup>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { addLog } from '@/api/dssRequest';
import uiHelpers from '@/shared/ui_helpers';
import ItemGroup from '@/components/generalComponents/uiComponents/ItemGroup';

export default {
  name: 'UserFavourites',
  mixins: [uiHelpers],
  components: {
    ItemGroup,
  },
  computed: {
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    productFocused() {
      if (
        this.partnerGroupDetails == null ||
        this.partnerGroupDetails.Focus == null
      ) {
        return true;
      }

      if (this.partnerGroupDetails.Focus === 'Product') {
        return true;
      }

      return false;
    },
    favourites() {
      const favouriteMap = this.$store.getters['user/favourites'];
      if (favouriteMap == null || Object.keys(favouriteMap).length === 0) {
        return [];
      }

      return this.getFavourites(favouriteMap);
    },
  },
  methods: {
    /**
     * function to truncate the description so that it fits on one line
     */
    truncateName(name) {
      // truncate description of it has more dan 70 characters
      return name.length > 17 ? `${name.substr(0, 17)}... ` : name;
    },
    getFavourites(favouriteMap) {
      let favouriteArray = [];

      const events = this.loadEvents(favouriteMap);
      const categories = this.loadProductCategories(favouriteMap);
      const products = this.loadProducts(favouriteMap);

      if (this.productFocused) {
        // Load products and product categories before loading events
        favouriteArray = [...products, ...categories, ...events];
      } else {
        // Load events before loading products and product categories
        favouriteArray = [...events, ...products, ...categories];
      }

      return favouriteArray;
    },
    loadEvents(favouriteMap) {
      const events = [];

      if (favouriteMap != null && favouriteMap.Events != null) {
        favouriteMap.Events.forEach((event) => {
          event.FavouriteType = 'Event';

          const eventCopy = { ...event };
          eventCopy.FavouriteType = 'Event';
          events.push(eventCopy);
        });
      }

      return events;
    },
    loadProducts(favouriteMap) {
      const products = [];

      if (favouriteMap != null && favouriteMap.Products != null) {
        favouriteMap.Products.forEach((product) => {
          const productCopy = { ...product };
          productCopy.FavouriteType = 'Product';
          products.push(productCopy);
        });
      }

      return products;
    },
    loadProductCategories(favouriteMap) {
      const categories = [];

      if (favouriteMap != null && favouriteMap.ProductCategories != null) {
        favouriteMap.ProductCategories.forEach((productCategory) => {
          const categoryCopy = { ...productCategory };
          categoryCopy.FavouriteType = 'ProductCategory';
          categories.push(categoryCopy);
        });
      }

      return categories;
    },
    goTo(favourite) {
      const userId = this.$store.getters['auth/userName'];

      if (favourite.FavouriteType === 'Event') {
        // Add user interaction to log
        addLog(userId, favourite.EventId, 'Event', 'Home', -1);

        this.goToPage('EventDetails', {
          event_id: favourite.EventId,
        });
      } else if (favourite.FavouriteType === 'Product') {
        // Add user interaction to log
        addLog(userId, favourite.Id, 'Product', 'Home', -1);

        // always go to the first category of the product
        const firstElement = 0;
        // route to the details of the product
        this.goToPage('ProductWithCategory', {
          event_id: favourite.EventId,
          category_id: favourite.Categories[firstElement].Id,
          product_id: favourite.Id,
        });
      } else if (favourite.FavouriteType === 'ProductCategory') {
        // Add user interaction to log
        addLog(userId, favourite.Id, 'ProductCategory', 'Home', -1);

        this.goToPage('ProductCategory', {
          event_id: favourite.EventId,
          category_id: favourite.Id,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.overflow {
  overflow-x: auto;
}
</style>
